const ExcelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 64 64"
    >
      <defs>
        <linearGradient
          id="a"
          x1="5.56"
          y1="13.916"
          x2="26.441"
          y2="50.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#18884f" />
          <stop offset="0.5" stopColor="#117e43" />
          <stop offset="1" stopColor="#0b6631" />
        </linearGradient>
      </defs>
      <title>Excel_64x</title>
      <path
        d="M39,26,15,32V57.333A2.667,2.667,0,0,0,17.667,60H60.333A2.667,2.667,0,0,0,63,57.333V46Z"
        fill="#185c37"
      />
      <path
        d="M39,4H17.667A2.666,2.666,0,0,0,15,6.667V18L39,32l12,5,12-5V18Z"
        fill="#21a366"
      />
      <path
        d="M60.333,4H39V18H63V6.667A2.666,2.666,0,0,0,60.333,4Z"
        fill="#33c481"
      />
      <rect x="39" y="32" width="24" height="14" fill="#107c41" />
      <rect x="15" y="18" width="24" height="14" fill="#107c41" />
      <path
        d="M33,18.63V48.369a1.961,1.961,0,0,1-.045.451A2.607,2.607,0,0,1,30.378,51H15V16H30.378A2.621,2.621,0,0,1,33,18.63Z"
        opacity="0.2"
      />
      <path
        d="M34,18.759V46.24a3.73,3.73,0,0,1-1.163,2.709A3.683,3.683,0,0,1,30.278,50H15V15H30.278A3.754,3.754,0,0,1,34,18.759Z"
        opacity="0.1"
      />
      <path
        d="M33,18.651v27.7A2.632,2.632,0,0,1,30.378,49H15V16H30.378A2.632,2.632,0,0,1,33,18.651Z"
        opacity="0.2"
      />
      <path
        d="M32,18.651v27.7A2.642,2.642,0,0,1,29.359,49H15V16H29.359A2.641,2.641,0,0,1,32,18.651Z"
        opacity="0.1"
      />
      <rect width="64" height="64" fill="none" />
      <rect y="16" width="32" height="32" rx="2.667" fill="url(#a)" />
      <path
        d="M8.258,40.666l5.609-8.691L8.73,23.333h4.134l2.8,5.524q.387.786.532,1.172h.036q.277-.627.58-1.22l3-5.476h3.8l-5.27,8.594,5.4,8.739H19.7L16.466,34.6a4.98,4.98,0,0,1-.387-.809H16.03a3.808,3.808,0,0,1-.374.785L12.32,40.666Z"
        fill="#fff"
      />
    </svg>
  )
}

export default ExcelIcon
